import { CanvasEx } from '@/typings/canvas';
import { BaseCanvasElement } from '@/typings/customilyElements/canvasElements';
import { ElementsPageEps } from '@/typings/customilyElements/elementsPageEps';

export const setPageEpsLock = (space: ElementsPageEps, canvas: CanvasEx, locked: boolean, elementUpdate = false) => {
    if (!space) return;
    if (space.locked === locked) {
        return;
    }
    space.locked = locked;
    const elements = canvas.getPageEpsElements(space);
    canvas.discardActiveObject();
    for (const element of elements) {
        (element as BaseCanvasElement).set(!elementUpdate ? 'dirty' : 'locked', !elementUpdate ? true : locked);
        canvas.fire('object:modified', {
            target: element
        });
    }
    canvas.fire('pageeps:update');
    canvas.requestRenderAll();
};

export const togglePageEpsLock = (page: ElementsPageEps, canvas: CanvasEx, elementUpdate = false) => {
    if (!page) return;
    setPageEpsLock(page, canvas, !page.locked, elementUpdate);
};

export const setPageEpsVisibility = (
    page: ElementsPageEps,
    canvas: CanvasEx,
    visible: boolean,
    elementUpdate = false
) => {
    if (!page) return;
    if (page.visible === visible) {
        return;
    }
    page.visible = visible;
    const elements = canvas.getPageEpsElements(page);
    canvas.discardActiveObject();
    for (const element of elements) {
        (element as BaseCanvasElement).set(!elementUpdate ? 'dirty' : 'visible', !elementUpdate ? true : visible);
    }
    canvas.fire('pageeps:update');
    canvas.requestRenderAll();
};

export const togglePageEpsVisibility = (page: ElementsPageEps, canvas: CanvasEx, elementUpdate = false) => {
    if (!page) return;
    setPageEpsVisibility(page, canvas, !page.visible, elementUpdate);
};

export const handlePageEpsStatus = (canvas: CanvasEx, pageEpsIds: number[]) => {
    if (!canvas) {
        return;
    }
    if (!pageEpsIds || pageEpsIds.length === 0) {
        return;
    }

    if (canvas.isPreviewStep) {
        return;
    }

    const pageEpsElements = canvas.getElementsPageEps() || [];

    for (const pageEps of pageEpsElements) {
        if (pageEpsIds.includes(pageEps?.id)) {
            setPageEpsVisibility(pageEps, canvas, true);
            setPageEpsLock(pageEps, canvas, false);
            continue;
        }
        setPageEpsVisibility(pageEps, canvas, false);
        setPageEpsLock(pageEps, canvas, true);
    }
};
